export default "__VITE_ASSET__CNYJL4Pj__"